import SellersService from "@/api/services/sellers";

export default {
  namespaced: true,

  state: {
    sellers: [],
    isLoading: false,
    currentStoreExternalId: null,
  },

  mutations: {
    setSellers(state, sellers) {
      state.sellers = sellers;
    },
    setIsLoading(state, value) {
      state.isLoading = value;
    },
    setCurrentStoreExternalId(state, value) {
      state.currentStoreExternalId = value;
    },
    reset(state) {
      state.sellers = [];
      state.isLoading = false;
      state.currentStoreExternalId = null;
    },
  },

  actions: {
    async fetchSellers({ commit, state }, storeExternalId) {
      commit("setSellers", []);
      commit("setCurrentStoreExternalId", storeExternalId);
      commit("setIsLoading", true);
      try {
        const response = await SellersService.index(storeExternalId);
        if (response.success && state.currentStoreExternalId === storeExternalId) {
          commit("setSellers", response.data.sellers);
        }
      } finally {
        if (state.currentStoreExternalId === storeExternalId) {
          commit("setIsLoading", false);
        }
      }
    },

    reset({ commit }) {
      commit("reset");
    },
  },
};
